export default {
  Admin: 'Admin',
  Cutter: 'Cutter',
  Kunde: 'Kunde',
  Disponent: 'Disponent',
  Buchhaltung: 'Buchhaltung',
  Mitglied: 'Mitglied',
  asOptions (roles) {
    let result = []
    roles.forEach(r => result.push({'text': r.id, 'value': r.id}))
    return result
  },
  asArchivFilterOptions (roles) {
    let result = []
    result.push({'text': 'Cutter', 'value': 'Cutter'})
    result.push({'text': 'Kunde', 'value': 'Kunde'})
    result.push({'text': 'Disponent', 'value': 'Disponent'})
    return result
  }
}



// WEBPACK FOOTER //
// ./src/main/vue/models/Role.js